import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Tabs} from "@pg-design/tabs";

import {SortWithRadioDropdown} from "../../../atoms/sort_with_radio_dropdown/SortWithRadioDropdown";
import {SearchSortString} from "../constants/SearchSort";
import {useOfferListSort} from "../hooks/useOfferListSort";

export interface IOfferListSort {
    // name used for aria label tags, should be unique
    name: string;
    type?: "tabs" | "select";
    onSubmit?: () => void;
    latestQuerySort?: SearchSortString;
    isMobile?: boolean;
    onMobileResetForm?: () => void;
    className?: string;
}

export const sortOptions = [
    {
        title: "Polecane",
        value: SearchSortString.DEFAULT
    },
    {
        title: "Najnowsze",
        value: SearchSortString.LATEST
    },
    {
        title: "Najtańsze",
        value: SearchSortString.PRICE
    },
    {
        title: "Najtańsze (za m2)",
        value: SearchSortString.PRICE_M2
    },
    {
        title: "Termin oddania",
        value: SearchSortString.CONSTRUCTION_DATE
    }
];

const sortOptionForSelect: {value: SearchSortString; label: string; slug?: string | undefined}[] = sortOptions.map((option) => ({
    value: option.value,
    label: option.title
}));

export const OfferListSort: React.FC<IOfferListSort> = (props) => {
    const {sortHandler} = useOfferListSort({
        latestQuerySort: props.latestQuerySort,
        onSubmit: props.onSubmit || (() => null)
    });

    const onSave = (value: SearchSortString | null) => {
        sortHandler(value || SearchSortString.DEFAULT);
    };

    const onClear = () => {
        sortHandler(SearchSortString.DEFAULT);
    };

    return (
        <SortWrapper className={props.className}>
            {props.type === "select" ? (
                <SortWithRadioDropdown<SearchSortString>
                    dropdownShadow
                    dropdownPosition="right"
                    defaultValue={props.latestQuerySort}
                    sortOptions={sortOptionForSelect}
                    onClear={onClear}
                    onSave={onSave}
                />
            ) : (
                <Tabs color="gray" value={props.latestQuerySort} tabs={sortOptions} activeColor="gray" variant="contained" onChange={sortHandler} fullWidth />
            )}
        </SortWrapper>
    );
};

const SortWrapper = styled.div<{isMobile?: boolean}>`
    width: 100%;
    padding-top: 2rem;
    padding-bottom: 3.2rem;

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        padding-top: unset;
        background: #f9f9f9;
    }
    ${(props) =>
        props.isMobile &&
        css`
            padding-left: 2rem;
            padding-right: 2rem;
        `}
`;
